export default {
  Community: {
    editingCase: {
      titleTextareaPlaceholder: "وصف الحالة أو طرح سؤال",
      sybmolCount: "يجب أن يكون عدد الأحرف من {min} إلى {max}",
      wordsCount: "يجب أن يكون عدد الكلمات من {min} إلى {max}",
      mobiledocPlaceholder: "أخبرنا المزيد عن بيانات فحص المريض",
      mobiledocLabel: "بيانات الفحص",
      tags: "العلامات",
      editCase: "تحرير القضية",
      anamnesisPlaceholder: "أخبرنا المزيد عن التاريخ الطبي للمريض",
      treatmentPlaceholder: "أخبرنا المزيد عن علاج المريض",
      caseNotesPlaceholder: "أخبرنا المزيد عن القضية",
      questionNotesPlaceholder: "أخبرنا المزيد عن السؤال",
      addImage: "إرفاق صورة",
      anamnesis: "سوابق المريض",
      treatment: "العلاج",
      notes: "إضافة",
    },
    uploader: {
      case: {
        title: "إضافة حالة",
        description: "مشاركة حالات مثيرة للاهتمام من الممارسة الخاصة بك",
      },
      question: {
        title: "طرح سؤال",
        description: 'سيستجيب المستخدمون بشكل أسرع إذا حددت "سؤال".',
      },
    },
    title: "المجتمع",
    description: "تبادل المعرفة بين الأطباء حول الحالات السريرية",
    all_cases: "جميع الحالات",
    my_cases: "حالاتي",
    case: {
      shareLink: {
        1: "شاهد الحالة",
        2: "على المنصة “" + process.env.VUE_APP_INSTALL_NAME + "”:",
      },
    },
    noCasesLang: {
      1: "لا توجد حالات منشورة بهذه اللغة حتى الآن",
      2: "كن الأول الذي يشارك دراسة بتنسيق DICOM وتعرف على آراء الزملاء!",
    },
    filter: {
      status: {
        placeholder: "ترتيب الحالات",
        values: {
          popular: "الأكثر شهرة أولاً",
          actual: "الأحدث أولاً",
        },
        options: {
          base: "عرض أولاً",
          popular: "شائعة",
          actual: "حديثة",
        },
      },
      modality: {
        placeholder: "الطريقة",
      },
      bodypart: {
        placeholder: "منطقة الدراسة",
      },
      sex: {
        placeholder: "الجنس",
        values: {
          M: "ذكر",
          F: "أنثى",
        },
      },
    },
  },
  h1_community: "مجتمع الأطباء",
};
